import { compose, prop } from 'ramda';
import { createSelector } from 'reselect';

import { NAME } from './constants';

const getRoot = prop(NAME);

export const getSort = compose(prop('sort'), getRoot);
export const getDocuments = compose(prop('documents'), getRoot);
export const getDocumentIdsToDelete = compose(prop('documentIdsToDelete'), getRoot);

export const getIsDocumentToDelete = createSelector(
	getDocumentIdsToDelete,
	(state, documentId) => documentId,
	(ids, documentId) => ids.includes(documentId),
);
